import { render, staticRenderFns } from "./ProjectTraceability.vue?vue&type=template&id=3842c222&scoped=true"
import script from "./ProjectTraceability.vue?vue&type=script&lang=js"
export * from "./ProjectTraceability.vue?vue&type=script&lang=js"
import style0 from "./ProjectTraceability.vue?vue&type=style&index=0&id=3842c222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842c222",
  null
  
)

export default component.exports